import ApiClientFactory from '../../api/client-factory';
import { PurchasablesApiService } from './service';

const service = new PurchasablesApiService(ApiClientFactory());

export function PurchasablesApiServiceFactory(): typeof service {
  return service;
}
